var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleQuotesL(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.82 14.434c-.86-.911-1.32-1.934-1.32-3.592 0-2.916 2.047-5.53 5.025-6.823l.744 1.148C5.49 6.671 4.947 8.622 4.73 9.852c.448-.232 1.034-.313 1.608-.26 1.504.14 2.689 1.374 2.689 2.908a2.917 2.917 0 0 1-2.917 2.917 3.228 3.228 0 0 1-2.29-.983Zm8.333 0c-.859-.911-1.32-1.934-1.32-3.592 0-2.916 2.047-5.53 5.026-6.823l.744 1.148c-2.78 1.504-3.323 3.455-3.54 4.685.447-.232 1.033-.313 1.608-.26 1.503.14 2.688 1.374 2.688 2.908a2.917 2.917 0 0 1-2.916 2.917c-.895 0-1.75-.409-2.29-.983Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleQuotesL);
export default __webpack_public_path__ + "static/media/double-quotes-l.42ee12a5155598fec51537e481fe5d80.svg";
export { ForwardRef as ReactComponent };